// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Form, Image, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// import routes file
// import utility file
import EleveService from '../../services/EleveService';
import SalledeclasseService from '../../services/SalledeclasseService';
import { Avatar } from '../../../elements/bootstrap/Avatar';

// import node module libraries
import { FormSelect } from 'components/elements/form-select/FormSelect';
import { ChevronLeft, ChevronRight } from 'react-feather';
import ReactPaginate from 'react-paginate';

const StudentsGridCard = () => {
	const [originalStudents, setOriginalStudents] = useState([]);
	const [students, setStudents] = useState([]);
	const [salledeclasse, setSalledeclasse] = useState([]);
	const [classeOptions, setClasseOptions] = useState([]);

	useEffect(() => {
		const fetchClassOptions = async () => {
			try {
				const classes = await SalledeclasseService.getClassOptions();
				setClasseOptions(classes);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchClassOptions();
	}, []);

	const formatIntituleClasse = (value) => {
		return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	};

	const CLASSE_CHOICES = classeOptions;

	// Functions for display formatting
	const formatValue = (value, columnId) => {
		if (typeof value === 'string') {
			if (columnId === 'nom' || (columnId === 'matricule' && value)) {
				return value.toUpperCase();
			} else if (columnId === 'statut_eleve' || columnId === 'genre') {
				return (
					value && value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
				);
			} else {
				return value;
			}
		} else if (columnId === 'salledeclasse') {
			return value && value.intitule_classe
				? formatIntituleClasse(value.intitule_classe).toUpperCase()
				: '';
		}
		return value;
	};

	const getInitials = (student) => {
		const firstName = student.prenom
			? student.prenom.charAt(0).toUpperCase()
			: '';
		const lastName = student.nom ? student.nom.charAt(0).toUpperCase() : '';
		return `${lastName} ${firstName}`;
	};

	const formatStatutEleve = (value) => {
		return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	};

	const getSalledeclasseById = (salledeclasseId) => {
		return salledeclasse.find((item) => item.id === salledeclasseId) ?? {};
	};

	useEffect(() => {
		Promise.all([
			EleveService.getAllEleves(),
			SalledeclasseService.getAllSalledeclasse()
		]).then(([elevesData, salledeclasseData]) => {
			setOriginalStudents(elevesData);
			setStudents(elevesData);
			setSalledeclasse(salledeclasseData);
		});
	}, []);

	// searching code started
	const [searchTerm, setSearchTerm] = useState('');

	const getSearchTerm = (event) => {
		let searchTerm = event.target.value;
		setSearchTerm(searchTerm);
		if (searchTerm !== '') {
			const newStudentsList = originalStudents.filter((student) => {
				let studentData = Object.values(student).join(' ').toLowerCase();
				let salledeclasseData = Object.values(
					getSalledeclasseById(student.salledeclasse)
				)
					.join(' ')
					.toLowerCase();
				let statutEleveData = formatStatutEleve(
					student.statut_eleve
				).toLowerCase();
				let isGenreSearch =
					searchTerm.toLowerCase() === 'masculin' ||
					searchTerm.toLowerCase() === 'feminin';
				if (isGenreSearch) {
					let genderChar = searchTerm.toLowerCase() === 'masculin' ? 'm' : 'f';
					return student.genre.toLowerCase() === genderChar;
				}
				return (
					studentData.includes(searchTerm.toLowerCase()) ||
					salledeclasseData.includes(searchTerm.toLowerCase()) ||
					statutEleveData.includes(searchTerm.toLowerCase())
				);
			});
			setStudents(newStudentsList);
			setPageNumber(0);
		} else {
			setStudents(originalStudents);
		}
	};

	const getFilterTerm = (event) => {
		let filterTerm = event.target.value;
		if (filterTerm !== '') {
			const newStudentsList = originalStudents.filter((student) => {
				return student.salledeclasse === Number(filterTerm);
			});
			setStudents(newStudentsList);
			setPageNumber(0);
		} else {
			setStudents(originalStudents);
		}
	};

	const studentsWithSalledeclasse = students.map((student) => ({
		...student,
		salledeclasse: getSalledeclasseById(student.salledeclasse)
	}));

	// paging start
	const [pageNumber, setPageNumber] = useState(0);
	const studentsPerPage = 8;
	const pagesVisited = pageNumber * studentsPerPage;
	const pageCount = Math.ceil(
		studentsWithSalledeclasse.length / studentsPerPage
	);
	const changePage = ({ selected }) => {
		setPageNumber(selected);
	};

	const displayStudents = studentsWithSalledeclasse
		.slice(pagesVisited, pagesVisited + studentsPerPage)
		.map((student) => {
			const initials = getInitials(student);
			return (
				<Col xl={3} lg={6} md={6} sm={12} key={student.id}>
					<Card className="mb-5">
						<Card.Body>
							<div className="text-center">
								<div className="position-relative mb-2">
									<Link to={`/education/eleves/${student.id}`}>
										{student.photo ? (
											<Image
												src={student.photo}
												alt=""
												className="rounded-circle avatar-xl"
											/>
										) : (
											<Avatar
												type="initial"
												size="xl"
												name={initials || ''}
												className="rounded-circle"
												alt={initials || ''}
											/>
										)}
									</Link>
								</div>
								<Link to={`/education/eleves/${student.id}`}>
									<h4 className="mb-0">{formatValue(student.nom, 'nom')}</h4>
								</Link>
								<p className="mb-0">
									{formatValue(student.matricule, 'matricule')}
								</p>
							</div>
							<div className="d-flex justify-content-between border-bottom py-2 mt-6">
								<span>Genre</span>
								<span className="text-dark">
									{formatValue(student.genre, 'genre')}
								</span>
							</div>
							<div className="d-flex justify-content-between border-bottom py-2">
								<span>Statut</span>
								<span>{formatStatutEleve(student.statut_eleve)}</span>
							</div>
							<div className="d-flex justify-content-between pt-2">
								<span>Classe</span>
								<span className="text-dark">
									{formatValue(student.salledeclasse, 'salledeclasse')}
								</span>
							</div>
						</Card.Body>
					</Card>
				</Col>
			);
		});
	// end of paging

	return (
		<Fragment>
			<div className="mb-4">
				<Row className="justify-content-md-between mb-4 mb-xl-0 ">
					<Col xxl={3} lg={4} md={6} xs={12}>
						{/* search records */}
						<div className="mb-2 mb-lg-4">
							<Form.Control
								type="search"
								placeholder="Rechercher un élève"
								value={searchTerm}
								onChange={getSearchTerm}
							/>
						</div>
					</Col>
					<Col xxl={3} lg={4} md={6} xs={12}>
						{/* records filtering options */}
						<Form.Control
							as={FormSelect}
							placeholder="Filtrer par salle de classe"
							options={CLASSE_CHOICES}
							onChange={getFilterTerm}
						/>
					</Col>
				</Row>
			</div>
			<Row>
				{displayStudents.length > 0 ? (
					displayStudents
				) : (
					<Col>Aucun élève correspondant n'a été trouvé.</Col>
				)}
			</Row>
			<ReactPaginate
				previousLabel={<ChevronLeft size="14px" />}
				nextLabel={<ChevronRight size="14px" />}
				pageCount={pageCount}
				onPageChange={changePage}
				containerClassName={'justify-content-center mb-0 pagination'}
				previousLinkClassName={'page-link mx-1 rounded'}
				nextLinkClassName={'page-link mx-1 rounded'}
				pageClassName={'page-item'}
				pageLinkClassName={'page-link mx-1 rounded'}
				disabledClassName={'paginationDisabled'}
				activeClassName={'active'}
			/>
		</Fragment>
	);
};

export default StudentsGridCard;
